import { render, staticRenderFns } from "./Infoboard.vue?vue&type=template&id=0331d182&scoped=true&"
import script from "./Infoboard.vue?vue&type=script&lang=js&"
export * from "./Infoboard.vue?vue&type=script&lang=js&"
import style0 from "./Infoboard.vue?vue&type=style&index=0&id=0331d182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0331d182",
  null
  
)

export default component.exports